import React from "react";
import type { CustomFunctionUiActionApi_UiActionDto } from "src/api/generated/erp/customFunctions/triggers/uiAction/api/customFunctionUiActionApi.ts";
import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";

import type { CustomAppAvailableLauncher } from "src/api/generated/erp/customApps/runtime/customAppAvailableLauncher.ts";

export type CustomUiAction =
	| (Omit<CustomFunctionUiActionApi_UiActionDto, "views"> & {
			kind: "function";
			locations: CustomFunctionUiActionApi_UiActionDto["views"];
	  })
	| (CustomAppAvailableLauncher["launcher"] & CustomAppAvailableLauncher & { kind: "app" });

export const CustomUiActionsContext = React.createContext<CustomUiAction[] | undefined>(undefined);

export function useCustomUiActions() {
	return useContextOrThrow(CustomUiActionsContext);
}
